module.exports = __webpack_public_path__ + "assets/img/btn-detail-62e907b6.png";